import "core-js/modules/es.array.push.js";
import { ref, onMounted, computed } from 'vue';
import { useRouter } from "vue-router";
import { useStore } from 'vuex';
import httpRequest from '@/request/index';
import { showLoadingToast, showFailToast, closeToast } from 'vant';
export default {
  setup() {
    const store = useStore();
    const router = useRouter();
    const banner = ref([]);
    const newsGoods = ref([]);
    const recGoods = ref([]);
    const Notice = ref([]);
    let keywords = ref("");
    const goSearch = val => {
      router.push({
        path: "/goods/search",
        query: {
          keywords: val
        }
      });
    };
    onMounted(async () => {
      await store.dispatch("cklogin").then(() => {
        if (!store.state.isLogin) {
          router.replace("/login");
        }
      });
      showLoadingToast({
        message: '加载中',
        forbidClick: true
      });
      httpRequest({
        method: "get",
        url: "?file=index"
      }).then(res => {
        closeToast();
        if (res.state == 1) {
          banner.value = res.banner;
          newsGoods.value = res.news;
          recGoods.value = res.sell;
          Notice.value = res.notice;
        } else {
          showFailToast(res.msg);
        }
      });
    });
    return {
      banner,
      newsGoods,
      recGoods,
      Notice,
      keywords,
      goSearch
    };
  }
};